import MyobLogoGenericRound from './myob-logo-generic-round';

export * from './myob-logo-generic-round';
export default MyobLogoGenericRound;
